import React, {FC, useEffect, useState} from "react";

import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link, useParams } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import {RootState} from "../../app/store";
import { useNavigate } from "react-router-dom";
import {login} from "../../app/authorizationReducers";
import AuthService from "../../app/services/authService";
import { toast } from "react-hot-toast";
import Notify from "components/Notify";
import UserService from "app/services/userService";
import { Notification } from "app/helpers/sendnotification";


export interface PageLoginProps {
  className?: string;
}




interface Params{
  token:string
}
const PageForgot: FC<PageLoginProps> = ({ className = "" }) => {

  const  params: Params | any = useParams() ;
  const navigate = useNavigate();
  const [emailForm, setEmailForm] = useState<boolean> (true)
  useEffect(() => {
    if(params.token){
      setEmailForm(false)
    }
    // if(loggedIn){
    //   navigate("/");
    // }
    console.log()
  }, [])

 
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    UserService.forgot(e.target.elements.email.value).then(data => {
      console.log(data)
      if (data.detail == `User with email ${e.target.elements.email.value} not found`)
        Notification('error', "Nous n'avions pas trouvé de compte avec cette email!")
      if (data == 'ok')
        Notification('success', "un lien de changement de mot de passe a été envoyé à votre adresse e-mail")
      
    })

  }

  const passSubmit = async (e: any) => {
    e.preventDefault();
    const password = e.target.elements.password.value
    const password2 = e.target.elements.password2.value
    let message = "Votre mot de passe a été réinitialisé, vous pouvez maintenant vous connecter"
    let status = "success"
    let error = false
    if(password.length < 8){
      message = "Votre mot de passe est très court"
      status = "error"
      error = true
    }
    if(password != password2){
      message = "Mot de passe de confirmation incorrect"
      status = "error"
      error = true
    }

    

    const data = {
      token: params.token,
      password: password,
      password2: password2
    }
    if(!error){
      UserService.updatePassword(data).then(data => {
        if(data == 'ok'){
          toast.custom((t) => (
            <Notify 
                t={t}
                message={message}
                status={status}
            />),
            { position: "top-right", id: "nc-product-notify", duration: 3000 }
          )
        }
      }).catch(error => 
        console.log(error)
      );
    }else{
      toast.custom((t) => (
        <Notify 
            t={t}
            message={message}
            status={status}
        />),
        { position: "top-right", id: "nc-product-notify", duration: 3000 }
      )
    }
    
  

  }
  return (
          <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
            <Helmet>
              <title>Roupa || Mot de passe oublié?</title>
            </Helmet>
            <div className="container mb-24 lg:mb-32">
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                 Réinitialiser votre mot de passe
              </h2>
              <div className="max-w-md mx-auto space-y-6">
                <div className="grid gap-3">
               
                </div>
                {
                  emailForm ?
                  <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6" >
                  <label className="block">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Adresse mail
                    </span>
                    <Input
                      type="email"
                      name="email"
                      placeholder="example@example.com"
                      className="mt-1"
                    />
                  </label>
                 
                  <ButtonPrimary type="submit">Réinitialiser</ButtonPrimary>
                </form>
                :
                <form onSubmit={passSubmit} className="grid grid-cols-1 gap-6" >
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Mot de passe
                  </span>
                  <Input
                    type="password"
                    name="password"
                   
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Confirmer votre mot de passe
                  </span>
                  <Input
                    type="password"
                    name="password2"
                   
                    className="mt-1"
                  />
                </label>
                <ButtonPrimary type="submit">Réinitialiser</ButtonPrimary>
              </form>
                }
           

                {/* ==== */}
                
              </div>
            </div>
          </div>
          );
};

export default PageForgot;

